<template>
  <v-container fluid>
    <v-card
      class="mx-auto"
      max-width="600"
      outlined
    >
      <v-card-title class="pa-2 d-flex justify-space-between">
        {{ $t('locations.title') }}
        <v-btn fab small @click="showCreateDialog()">
          <v-icon>mdi-map-marker-plus</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="ma-0 pa-0">
        <v-list two-line class="px-2">
          <v-list-item v-for="(c, i) in sortedLocations" :key="i" class="litem px-0">
            <v-list-item-content>
              <v-list-item-title class="title">{{getLocationName(c.lid)}}</v-list-item-title>
              <v-list-item-subtitle>
                <span class="white--text ml-2">{{dateDiffStr(c.time)}}</span>
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-icon>
              <v-icon v-if="isOwner(c.owner)" @click="showQRDialog(c.lid)" class="mt-4 mr-2">mdi-qrcode</v-icon>
              <v-icon @click="resetTime(c.lid)" class="mt-4 mr-2">mdi-eye-check-outline</v-icon>
              <v-icon @click="showEditDialog(c.lid)" class="mt-4">mdi-menu</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
    <!-- create dialog -->
    <v-dialog v-model="dialogCreateLocation" persistent max-width="350" light>
      <v-card>
        <v-card-title class="d-flex justify-space-between px-3 pt-2">
            {{ $t('locations.dialogTitle')}}
            <v-icon class="float-right" @click="dialogCreateLocation = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
          <v-form v-model="valid">
            <v-container>
              <v-row justify="center" align="center">
                  <v-text-field
                    v-model="formData.name"
                    :counter="100"
                    :label="$t('locations.name')"
                  ></v-text-field>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <v-btn color="primary" small @click="onCreate">{{ $t('app.btn.create') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- edit dialog -->
    <v-dialog v-model="dialogEditLocation" persistent max-width="350" light>
      <v-card>
        <v-card-title class="d-flex justify-space-between px-3 pt-2">
            {{ $t('locations.dialogTitle')}}
            <v-icon class="float-right" @click="dialogEditLocation = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
          <v-form v-model="valid">
            <v-container>
              <v-row justify="center" align="center">
                  <v-text-field
                    v-model="formData.lid"
                    :label="$t('app.att.lid')"
                    readonly
                    required
                    disabled
                  ></v-text-field>
              </v-row>
              <v-row justify="center" align="center">
                  <v-text-field
                    v-model="formData.name"
                    :counter="100"
                    :label="$t('locations.name')"
                  ></v-text-field>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between">
          <v-btn color="grey lighten-1" class="white--text" small @click="onDelete">{{ $t('app.btn.delete') }}</v-btn>
          <v-btn color="primary" small @click="onUpdate">{{ $t('app.btn.save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- QR dialog -->
    <v-dialog v-model="dialogQR" persistent max-width="350" light>
      <v-card>
        <v-card-title class="d-flex justify-end ma-0">
            <v-icon @click="dialogQR = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-subtitle>
          <v-row justify="center">
            <h3>{{ formData.name }}</h3>
          </v-row>
        </v-card-subtitle>
        <v-card-text>
          <v-row justify="center">
            <vue-qrcode v-if="formData.showName" :value="formData.linkName" :width="200" :maskPattern="0" :margin="0"/>
            <vue-qrcode v-else :value="formData.link" :width="200" :maskPattern="0" :margin="0"/>
          </v-row>
          <v-row justify="center">
            <h4>meeconn</h4>
          </v-row>
          <v-row class="mt-4" v-if="formData.name">
            <v-col cols="10" class="py-0">
              <v-checkbox
                v-model="formData.showName"
                :label="$t('locations.showName')"
              ></v-checkbox>
            </v-col>
            <v-col cols="2" class="px-0 py-4">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon class="pt-2" v-on="on">mdi-information</v-icon>
                </template>
                <span>{{ $t('locations.showNameTooltip') }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row class="d-flex justify-center pt-2">
            <v-btn color="primary" small @click="downloadPDF()">{{ $t('app.btn.download')}}</v-btn>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" small @click="dialogQR = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import VueQrcode from 'vue-qrcode'

export default {
  name: 'Locations',
  components: {
    VueQrcode
  },
  data: () => ({
    dialogCreateLocation: false,
    dialogEditLocation: false,
    dialogQR: false,
    valid: false,
    formData: {
      lid: '',
      name: '',
      showName: false
    }
  }),
  computed: {
    link: function() {
      return encodeURI(this.$http.defaults.baseURL + '/c/' + this.cor + ';' + this.lid + (this.nick ? ';' + this.nick : ''))
    },
    ...mapGetters(['sortedLocations'])
  },
  methods: {
    showCreateDialog() {
        this.formData.name = ''
        this.dialogCreateLocation = true
    },
    showEditDialog(lid) {
      var data = this.$store.state.data.locations.find(c => c.lid === lid)
      this.valid = false
      this.formData.lid = data.lid
      this.formData.name = this.$store.state.locationNames['' + lid]
      this.dialogEditLocation = true
    },
    showQRDialog(lid) {
        this.formData.lid = lid
        this.formData.name = this.$store.state.locationNames['' + lid]
        this.formData.showName = false
        this.formData.link = encodeURI(this.$http.defaults.baseURL + '/p/' + lid)
        this.formData.linkName = encodeURI(this.$http.defaults.baseURL + '/p/' + lid + ';' + this.formData.name)
        this.dialogQR = true
    },
    resetTime(lid) {
      this.$store.commit('resetTimeLocation', lid)
      this.$emit('toSynchronize')
    },
    isOwner(lid) {
      return this.$store.state.data.pid === lid
    },
    async onCreate() {
      await this.$store.dispatch('createLocation', this.formData)
      this.dialogCreateLocation = false
      this.$emit('toSynchronize')
    },
    onUpdate() {
      this.$store.commit('addLocationName', this.formData)
      this.dialogEditLocation = false
    },
    onDelete() {
      this.$store.commit('deleteLocation', this.formData)
      this.dialogEditLocation = false
      this.$emit('toSynchronize')
    },
    getLocationName(lid) {
      var name = this.$store.state.locationNames['' + lid]
      if (name) {
        return name
      } else {
        return lid
      }
    },
    dateDiffStr(dateStr) {
      var now = new Date()
      var createTime = new Date(dateStr)
      var diff = Math.floor((now - createTime) / (1000 * 3600 * 24))
      if (diff == 0) {
        return 'dnes'
      } else {
        return '- ' + diff + 'd'
      }
    },
    async downloadPDF() {
      try {
        var url = ''
        if (this.formData.showName) {
          url = this.formData.linkName
        } else {
          url = this.formData.link
        }
        var res = await this.$store.dispatch('qrpdf', {lid: this.formData.lid, url: url})
        var data = res.data
        var blob = new Blob([data], { type: 'application/octet-stream;' })
        var objdata = this.window.URL.createObjectURL(blob);
        //for IE
        if (this.window.navigator && this.window.navigator.msSaveOrOpenBlob) {
            this.window.navigator.msSaveOrOpenBlob(blob);
            return;
        }
        var link = this.document.createElement('a')
        link.href = objdata
        link.download=this.formData.lid + ".pdf"
        link.click()
      } catch (err) {
          this.$parent.$emit('error', this.$t('locations.errQRpdf') + ' ' + err)
      }
    }
  }
}
</script>
<style>
.litem {
  border-top: 1px solid grey;
}
</style>
